import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';
import moment from 'moment';


import { CancelButton } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect, renderDateField, renderCheckBox } from '../../../../../../../components/reduxFields';
import { getBehaviourReductionSingleGraphData } from '../../../../DataCollection/BehaviorReductiom/Behavior/actions/behaviorActions';
import PercentageOfIntervalsGraph from './percentageOfIntervalsGraph';
import TimeofDayGraph from './timeOfDayGraph';

const partialIntervalGraphType = [
    { id: 1, value: "% of Intervals" },
    { id: 2, value: "Time of day" }
]

class PartialIntervalGraphModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedGraphType: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      displayLegendCheckBox: true,
      disableLegend: true,
      hideGridlines: false,
      displayAverageCheckBox: true,
      displayAverage: false,
      graphByStaff: false,
      displaySavedPhaseChangeLines: false,      
      phaseChangeLineDataFlag : true,      
      displayPhaseChangeLinesCheckbox: true,
    };
    this.setPhaselineState = this.setPhaselineState.bind(this);    
  }

  componentWillMount() {
    if(this.props.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL") {
        this.setState({
            graphType: partialIntervalGraphType
        });
    }     
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  checkDisable = (event, Id) => {   
    if(Id === 'disableLegend')
    {
      this.setState({ disableLegend: !event.target.checked }, () => this.loadData());
    }
    else if(Id === 'hideGridlines')
    {
      this.setState({ hideGridlines: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'displayAverage')
    {
      this.setState({ displayAverage: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'graphByStaff')
    {
      this.setState({ graphByStaff: event.target.checked ? true : false }, () => this.loadData());      
    } 
    else if(Id === 'displaySavedPhaseChangeLines')
    {
      this.setState({ displaySavedPhaseChangeLines: event.target.checked ? true : false,
        phaseChangeLineDataFlag : true,        
      });      
    }   
  }

  loadData() {
    let FromDate = moment(this.state.FromDate).format('YYYY-MM-DD');
    let ToDate =  moment(this.state.ToDate).format('YYYY-MM-DD');
    if(this.state.selectedGraphType)
    {
      this.props.getBehaviourReductionSingleGraphData(this.props.patientId, this.props.recordingTypeName, this.props.behaviorsReductionId, FromDate, ToDate, this.state.graphByStaff, this.state.selectedGraphType.toUpperCase());
    }
  }

  handleNewRequestGraphType = (input, selectedRecord) => { 
    input.onChange(selectedRecord.value);    
    this.setState({ 
      displaySavedPhaseChangeLines: false,      
      phaseChangeLineDataFlag : true,      
    }, () => { 
      this.props.dispatch(change('PartialIntervalGraphModalForm', `displaySavedPhaseChangeLines`, false));      
    });
    if(selectedRecord.label.toUpperCase() === "% OF INTERVALS") {  
        this.setState({
            displayLegendCheckBox : true,
            selectedGraphType: 'PERCENTAGE OF INTERVALS',
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());  
    } else  if(selectedRecord.label.toUpperCase() === "TIME OF DAY") {   
        this.setState({
            displayLegendCheckBox : false,
            selectedGraphType: selectedRecord.label.toUpperCase(),
            displayAverageCheckBox: false,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } 
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value,      
      displaySavedPhaseChangeLines: false,      
      phaseChangeLineDataFlag : true,     
    }, () => { 
      this.props.dispatch(change('PartialIntervalGraphModalForm', `displaySavedPhaseChangeLines`, false));    
      this.loadData();});
  }

  setPhaselineState(phaseChangeLineDataFlag) {          
    this.setState({
      phaseChangeLineDataFlag : phaseChangeLineDataFlag,      
    });
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
      ];
    return <Dialog className="custom_modal_new_appointment" title={this.props.modalTitle} modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className='row'>
            <div className="col-sm-3 mt-40">
                <Field
                    name='graphTypeId'
                    label="Graph Type"
                    options={this.state.graphType}
                    handleNewRequest={this.handleNewRequestGraphType}
                    component={renderAutoCompleteSingleSelect}
                />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    maxDate={this.state.ToDate}
                    component={renderDateField} />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
            </div>
            {this.state.displayLegendCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="disableLegend" 
                    label="Disable Legends"
                    onChange={(e) => this.checkDisable(e, 'disableLegend')}
                    component={renderCheckBox} />
            </div>}
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="hideGridlines" 
                    label="Hide Gridlines"
                    onChange={(e) => this.checkDisable(e, 'hideGridlines')}
                    component={renderCheckBox} />
            </div>
            {this.state.displayAverageCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayAverage" 
                    label="Display Average"
                    onChange={(e) => this.checkDisable(e, 'displayAverage')}
                    component={renderCheckBox} />
            </div>}
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="graphByStaff" 
                    label="View By Staff"
                    onChange={(e) => this.checkDisable(e, 'graphByStaff')}
                    component={renderCheckBox} />
            </div>
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displaySavedPhaseChangeLines" 
                    label="Display saved phase change lines"
                    onChange={(e) => this.checkDisable(e, 'displaySavedPhaseChangeLines')}
                    component={renderCheckBox} />
            </div>}   
            </div>
          <div>
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "PERCENTAGE OF INTERVALS") && <PercentageOfIntervalsGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} graphByStaff={this.state.graphByStaff} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }           
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "TIME OF DAY") && <TimeofDayGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} graphByStaff={this.state.graphByStaff} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }
        </div>
      </Dialog>;
  }
}

PartialIntervalGraphModal = reduxForm({
    form: 'PartialIntervalGraphModalForm',
    enableReinitialize: true,
})(PartialIntervalGraphModal);


export default connect(null,{getBehaviourReductionSingleGraphData})(PartialIntervalGraphModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/PartialIntervalGraphModal/index.js